export default "__VITE_ASSET__0c028569__"